var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paymentActive",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M2,2H22V22H2Z",
    fill: "none",
    fillRule: "evenodd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M20.342,2.105A.991.991,0,0,0,19.3,2.2L15.922,4.733,12.542,2.2a1,1,0,0,0-1.193,0L7.97,4.733,4.59,2.2a.994.994,0,0,0-1.59.8V11.94c0,5.491,8.151,9.662,8.5,9.835l.447.226.447-.225c.348-.174,8.5-4.345,8.5-9.836V2.994A1,1,0,0,0,20.342,2.105ZM14.928,9.952H11.449a.5.5,0,1,0,0,.994h.994a2.485,2.485,0,0,1,.5,4.92V16.91H10.952v-.994H8.964V13.928h3.479a.5.5,0,1,0,0-.994h-.994a2.485,2.485,0,0,1-.5-4.92V6.97H12.94v.994h1.988Z",
    fill: "#5dc26a",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/paymentActive.8e97dd03a5288bb062327b6643ed595e.svg";
export { ForwardRef as ReactComponent };